import { render, staticRenderFns } from "./ListSoftware.vue?vue&type=template&id=77ab58ba"
import script from "./ListSoftware.vue?vue&type=script&lang=js"
export * from "./ListSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports